export const CLICK_OUTSIDE_ELEMENT_TO_EXCLUDE = {
  NOTI_BELL_BUTTON: 'notification-button',
};
